<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>后台账号列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <!-- <el-col :span="8">
          <el-input placeholder="请输入用户名称" v-model="queryInfo.query" clearable @clear="getUserList">
            <el-button slot="append" icon="el-icon-search" @click="getUserList"></el-button>
          </el-input>
        </el-col> -->
        <el-col :span="4" v-if="canLook == 1">
          <el-button type="primary" @click="addDialogVisible = true">添加角色</el-button>
        </el-col>

        <!-- <el-col :span="4">
          <el-button type="primary" @click="changeMyPwdDialogVisible = true">修改我的密码</el-button>
        </el-col> -->
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="userlist" border stripe>
        <!-- <el-table-column fixed type="selection" width="55"> </el-table-column> -->
        <el-table-column type="index"></el-table-column>
        <el-table-column label="昵称" prop="name"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="密码" prop="password"></el-table-column>
        <el-table-column label="角色身份" prop="roleTxt"></el-table-column>

        <el-table-column label="状态" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="userStateChanged(scope.row)"> </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="180px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.phone)"></el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeUserById(scope.row.phone)"></el-button>
            <!-- <el-tooltip effect="dark" content="分配角色" placement="top" :enterable="false">
              <el-button type="warning" icon="el-icon-setting" size="mini" @click="setRole(scope.row)"></el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog title="添加" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="130px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="登陆手机号" prop="phone">
          <el-input v-model="addForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="登陆密码" prop="password">
          <el-input v-model="addForm.password"></el-input>
        </el-form-item>
        <el-form-item label="分配角色" prop="role">
          <el-select v-model="addForm.role" filterable placeholder="请选择">
            <el-option v-for="item in rolesList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改用户的对话框 -->
    <el-dialog title="修改用户" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-form :model="editForm" :rules="addFormRules" ref="editFormRef" label-width="130px">
        <el-form-item label="登陆手机号">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="登陆密码" prop="password">
          <el-input v-model="editForm.password"></el-input>
        </el-form-item>
        <el-form-item label="分配角色" prop="role">
          <el-select v-model="editForm.role" filterable placeholder="请选择">
            <el-option v-for="item in rolesList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserInfo">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改用户自己密码的对话框 -->
    <el-dialog title="修改我的密码" :visible.sync="changeMyPwdDialogVisible" width="50%" @close="changeMyPwdDialogClosed">
      <el-form :model="changeMyPwdForm" :rules="changeMyPwdFormRules" ref="changeMyPwdFormRef" label-width="130px">
        <el-form-item label="原始密码" prop="password">
          <el-input v-model="changeMyPwdForm.password"></el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="newPwd">
          <el-input v-model="changeMyPwdForm.newPwd"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="changeMyPwdDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeMyPwdSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 分配角色的对话框 -->
    <el-dialog title="分配角色" :visible.sync="setRoleDialogVisible" width="50%" @close="setRoleDialogClosed">
      <div>
        <p>当前的用户：{{ userInfo.name }}</p>
        <p>当前的角色：{{ userInfo.roleTxt }}</p>
        <p>
          分配新角色：
          <el-select v-model="selectedRoleId" placeholder="请选择">
            <el-option v-for="item in rolesList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setRoleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveRoleInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    // 验证手机号的规则
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
      const regMobile = /^(0|86|17951)?(13[0-9]|14[0-9]|15[012356789]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/

      if (regMobile.test(value)) {
        return cb()
      }

      cb(new Error('请输入合法的手机号'))
    }

    return {
      canLook: 1,
      // 获取用户列表的参数对象
      queryInfo: {
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },

      userlist: [],
      total: 0,

      // 控制添加用户对话框的显示与隐藏
      addDialogVisible: false,

      // 添加用户的表单数据
      addForm: {
        phone: '',
        password: '',
        name: '',
        role: null,
      },

      // 添加表单的验证规则对象
      addFormRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '用户名的长度在6~15个字符之间',
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        role: [{ required: true, message: '请选择角色', trigger: 'blur' }],
      },

      // 添加用户的表单数据
      changeMyPwdDialogVisible: false,
      changeMyPwdForm: {
        password: '',
        newPwd: '',
      },

      changeMyPwdFormRules: {
        password: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '密码的长度在6~15个字符之间',
            trigger: 'blur',
          },
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '密码的长度在6~15个字符之间',
            trigger: 'blur',
          },
        ],
      },

      // 控制修改用户对话框的显示与隐藏
      editDialogVisible: false,
      // 查询到的用户信息对象
      editForm: {
        id: '',
        phone: '',
        password: '',
        name: '',
        role: null,
      },
      // 修改表单的验证规则对象
      editFormRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 6,
            max: 15,
            message: '密码的长度在6~15个字符之间',
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        role: [{ required: true, message: '请选择角色', trigger: 'blur' }],
      },

      // 控制分配角色对话框的显示与隐藏
      setRoleDialogVisible: false,
      // 需要被分配角色的用户信息
      userInfo: {},
      // 所有角色的数据列表
      rolesList: [],
      // 已选中的角色Id值
      selectedRoleId: null,
      multipleSelection: [],
      multipleSelectionjson: null,
    }
  },

  created() {
    this.getUserList()
    this.getUserRoleList()
  },

  methods: {
    async getUserList() {
      if (window.sessionStorage.getItem('pathCanLook') == 2) {
        //仅查看
        this.canLook = 2
      }
      const { data: res } = await this.$http.get('admin/managed/getAllManaged', {
        params: this.queryInfo,
      })
      if (res.code !== 200) {
        return this.$message.error('暂无用户列表！')
      }
      this.userlist = res.result.list
      this.total = res.result.count

      console.log(res)
    },

    async getUserRoleList() {
      const { data: res } = await this.$http.get('admin/managed/getManagedType')
      if (res.code !== 200) {
        return this.$message.error('暂无角色列表！')
      }
      this.rolesList = res.result

      console.log(res)
    },

    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize
      this.getUserList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage)
      this.queryInfo.pagenum = newPage
      this.getUserList()
    },

    // 监听 switch 开关状态的改变
    async userStateChanged(userinfo) {
      console.log(userinfo)
      const { data: res } = await this.$http.post('/admin/managed/updateUser', {
        status: userinfo.status,
        phone: userinfo.phone,
      })
      if (res.code !== 200) {
        userinfo.mg_state = !userinfo.mg_state
        return this.$message.error('更新用户状态失败！')
      }
      this.$message.success('更新用户状态成功！')
    },

    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },
    // 点击按钮，添加新用户
    addUser() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post('admin/managed/addManagedUser', this.addForm)
        if (res.code !== 200) {
          this.$message.error(res.message)
          return
        }
        this.$message.success(res.message)
        // 隐藏添加用户的对话框
        this.addDialogVisible = false
        // 重新获取用户列表数据
        this.getUserList()
      })
    },

    // 展示编辑用户的对话框
    async showEditDialog(phone) {
      console.log(phone)
      const { data: res } = await this.$http.get('admin/managed/baseManagedInfo', {
        params: { phone: phone },
      })
      if (res.code !== 200) {
        return this.$message.error('查询用户信息失败！')
      }
      this.editForm = res.result
      this.editDialogVisible = true
    },

    // 监听修改用户对话框的关闭事件
    editDialogClosed() {
      this.$refs.editFormRef.resetFields()
    },

    // 监听修改用户对话框的关闭事件
    changeMyPwdDialogClosed() {
      this.$refs.changeMyPwdFormRef.resetFields()
    },

    // 修改用户信息并提交
    editUserInfo() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        // 发起修改用户信息的数据请求
        const { data: res } = await this.$http.post('admin/managed/editManagedinfo', this.editForm)
        if (res.code !== 200) {
          return this.$message.error('更新用户信息失败！')
        }

        // 关闭对话框
        this.editDialogVisible = false
        // 刷新数据列表
        this.getUserList()
        // 提示修改成功
        this.$message.success('更新用户信息成功！')
      })
    },

    // 修改用户信息并提交
    changeMyPwdSubmit() {
      this.$refs.changeMyPwdFormRef.validate(async (valid) => {
        if (!valid) return
        // 发起修改用户信息的数据请求
        const { data: res } = await this.$http.post('admin/managed/changeMyPwd', this.changeMyPwdForm)
        if (res.code !== 200) {
          return this.$message.error('修改密码失败！')
        }

        // 关闭对话框
        this.changeMyPwdDialogVisible = false
        // 刷新数据列表
        this.getUserList()
        // 提示修改成功
        this.$message.success('更新密码成功！')
      })
    },

    // 根据Id删除对应的用户信息
    async removeUserById(phone) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch((err) => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post('admin/managed/deleteManagedInfo', { phone: phone })
      if (res.code !== 200) {
        return this.$message.error('删除用户失败！')
      }
      this.$message.success('删除用户成功！')
      this.getUserList()
    },

    // 展示分配角色的对话框
    async setRole(userInfo) {
      this.userInfo = userInfo
      console.log(userInfo)
      // 在展示对话框之前，获取所有角色的列表
      // const { data: res } = await this.$http.get('roles')
      // if (res.meta.status !== 200) {
      //   return this.$message.error('获取角色列表失败！')
      // }
      // this.rolesList = [{ name: '经销商', id: 0 }, { name: '管理员', id: 1 }]
      this.setRoleDialogVisible = true
    },

    // 点击按钮，分配角色
    async saveRoleInfo() {
      if (this.selectedRoleId == null) {
        return this.$message.error('请选择要分配的角色！')
      }

      const { data: res } = await this.$http.post('admin/user/setRole', {
        phone: this.userInfo.phone,
        role: this.selectedRoleId,
      })

      if (res.code !== 200) {
        return this.$message.error('更新角色失败！')
      }

      this.$message.success('更新角色成功！')
      this.getUserList()
      this.setRoleDialogVisible = false
    },

    // 监听分配角色对话框的关闭事件
    setRoleDialogClosed() {
      this.selectedRoleId = ''
      this.userInfo = {}
    },
  },
}
</script>

<style lang="less" scoped>
.aaaa {
  margin-left: 10px;
}
</style>
